import React, { FC, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch } from "react-redux";


const IoTAlertModal: FC<{ onClose: () => void, alertObj?: any }> = ({ onClose, alertObj }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);

  const [alert, setAlert] = useState<any>({
    stopTime: undefined,
    speedingTime: undefined,
    lowerSpeedThreshold: undefined,
    upperSpeedThreshold: undefined,
    name: "",
  });


  const updateAlert = (key: any, value: any) => {
    setAlert((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  useEffect(() => {
    if (alertObj) setAlert(alertObj);
  }, []);

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };
  const dispatch = useDispatch();
  const handleOk = () => {
    dispatch({
      type: "SEND_MESSAGE",
      payload: { message: alert.name, type: "alert-configuration", data: alert },
    });
    setIsModalVisible(false);
    onClose && onClose();
  };

  return (
    <Modal
      title="IoT Alert"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Row>
        <Col span={24}>
          <Input placeholder="Alert name"
            value={alert.name}
            onChange={(e) => updateAlert("name", e.target.value)} />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col span={24}>
          <Input placeholder="Stop Time (in minutes)"
            type={'number'}
            value={alert.stopTime}
            onChange={(e) => updateAlert("stopTime", parseInt(e.target.value))} />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col span={24}>
          <Input placeholder="Speeding Time (in minutes)"
            type={'number'}
            value={alert.speedingTime}
            onChange={(e) => updateAlert("speedingTime", parseInt(e.target.value))} />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col span={24}>
          <Input placeholder="Lower Speed threshold (in meters per second)"
            type={'number'}
            value={alert.lowerSpeedThreshold}
            onChange={(e) => updateAlert("lowerSpeedThreshold", parseInt(e.target.value))} />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col span={24}>
          <Input placeholder="Upper Speed threshold (in meters per second)"
            type={'number'}
            value={alert.upperSpeedThreshold}
            onChange={(e) => updateAlert("upperSpeedThreshold", parseInt(e.target.value))} />
        </Col>
      </Row>

      {!alertObj && (
        <Row className="action-grp mt-4">
          <Col span={14} className="pr-2">
            <Button
              className="beam-btn green-btn cover w-full"
              onClick={handleOk}
            >
              Add
            </Button>
          </Col>
          <Col span={10} className="pl-2">
            <Button
              className="beam-btn orange-btn bordered w-full"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      )}
    </Modal>
  );
};

export default IoTAlertModal;
